import { css, cx } from "@emotion/css";
import type * as React from "react";
import * as styles from "./LegacyDataTableStyles";
interface LegacyDataTableBodyProps {
    className?: string;
    children?: React.ReactNode;
}
export function LegacyDataTableBody({ className, children }: LegacyDataTableBodyProps): React.ReactElement {
    return <tbody className={cx(dataTableBodyStyles, className)}>{children}</tbody>;
}
export const dataTableBodyStyles = css({
    [`@media (max-width: ${styles.SmallScreen})`]: {
        display: "block",
    },
});
